import { CouponRedemptionStatus } from 'src/app/liabilities/models/model';

export const couponInfoMap = (redemptionStatus: CouponRedemptionStatus): CouponDetails => {
  switch (redemptionStatus) {
    case 'REDEEMED':
      return {
        icon: 'check_circle_filled',
        title: 'Kupon został doliczony',
        bodyTemplate: 'Po wykonaniu płatności, kwota kuponu zostanie zwrócona na Twoje konto w ciągu kilku dni.',
        showHelpButton: false,
      };
    case 'NO_VERIFIED_BILLERS':
      return {
        icon: 'info',
        title: 'Konieczna weryfikacja dostawcy',
        bodyTemplate: `
        <div>
          Posiadasz aktywny kupon, ale nie został on doliczony do koszyka, ponieważ dostawcy nie są zweryfikowani.<br />
          Prześlij na czacie zdjęcie dokumentu, zawierającego dane do płatności (nazwa dostawcy,
          numer rachunku bankowego).
        </div>
        <div>
          Jeśli dostawcy zostali już zweryfikowani, przelicz koszyk.
        </div>`,
        ctaButton: {
          name: 'ZWERYFIKUJ',
          action: AvailableAction.VERIFY,
        },
        showHelpButton: false,
      };
    case 'NOT_SELECTED_COUPON':
      return {
        icon: 'info',
        bodyTemplate:
          'Posiadasz aktywny kupon, ale nie został on doliczony do tego koszyka. Przelicz koszyk, aby aktywować kupon.',
        ctaButton: {
          name: 'PRZELICZ',
          action: AvailableAction.RECALCULATE,
        },
        showHelpButton: true,
      };
    case 'TITLE_BLACKLISTED':
      return {
        icon: 'info',
        bodyTemplate: `Aby kupon został doliczony, tytuły opłat muszą być unikalne. Upewnij się, że tytuły opłat
          są zgodne z informacją przedstawioną w dokumencie od dostawcy.`,
        ctaButton: {
          name: 'Anuluj płatność',
          action: AvailableAction.CANCEL_PAYMENT,
        },
        showHelpButton: true,
      };
    case 'BAD_SOURCE':
      return {
        icon: 'info',
        bodyTemplate: `Aby wykorzystać kupon, w koszyku muszą znajdować się opłaty pochodzące z
         <strong>Połączenia z systemem dostawcy (eBOK)</strong>.`,
        ctaButton: {
          name: 'Dodaj połączenie',
          action: AvailableAction.NEW_BILLER,
        },
        showHelpButton: true,
      };
    case 'NOT_VERIFIED_CUSTOMER':
      return {
        icon: 'info',
        bodyTemplate: `Aby wykorzystać kupon, konieczna jest weryfikacja konta użytkownika.`,
        ctaButton: {
          name: 'Zweryfikuj konto',
          action: AvailableAction.PHONE_VERIFICATION,
        },
        showHelpButton: false,
      };
    case 'LIABILITY_ALREADY_REDEEMED':
      return {
        icon: 'info',
        bodyTemplate:
          `Możliwość skorzystania z kuponu u dostawcy obecnego w koszyku została aktywowana na koncie innego użytkownika. ` +
          `Jeśli chcesz uzyskać zwrot za swoje płatności, dodaj do koszyka opłaty od innego dostawcy, połączonego z systemem eBOK.`,
        showHelpButton: false,
      };
    default:
      return;
  }
};

export interface CouponDetails {
  icon: IconType;
  title?: string;
  bodyTemplate: string;
  ctaButton?: CtaButton;
  showHelpButton: boolean;
}

export type IconType = 'check_circle_filled' | 'info' | 'error_filled';

export interface CtaButton {
  name: string;
  action: AvailableAction;
}

export enum AvailableAction {
  'RECALCULATE',
  'CANCEL_PAYMENT',
  'NEW_BILLER',
  'PHONE_VERIFICATION',
  'VERIFY',
}
